export enum InvoicesErrorCodes {
    INVOICE_NOT_FOUND_ERROR = 41010,
    INVALID_REQUEST_ERROR = 41000,
    INVOICE_STATUS_NOT_FOUND = 41020,
    INVOICE_SHIPPING_NOT_FOUND = 41030,
    INVOICE_NOTE_NOT_FOUND = 41040,
    INVOICE_PULLER_SCHEDULE_NOT_FOUND = 41050,
    TIMESLOT_UNAVAILABLE = 41060,
    INVOICE_ALREADY_BOOKED_ERROR = 41070,
    SHIPPING_INVOICE_ALREADY_EXISTS = 41080,
    PAYMENT_STILL_OWING_EXCEPTION = 41090,
    INVOICE_OVERPAYMENT_ERROR = 41100,
    SHIPPING_NOT_FOUND_ERROR = 41110,
    INOICE_IDS_DO_NOT_MATCH = 41120,
    MULTIPLE_PAYMENTS_STILL_OWING_ERROR = 41130,
    INVOICE_LIST_MISMATCH_ERROR = 41140,
    DOES_NOT_OWN_INVOICE = 41150,
    UNSUPPORTED_PAYMENT_TYPE = 41160,
    INVALID_MAPPING_ERROR = 41170,
    IMMUTABLE_UPDATE_ATTEMPT_ERROR = 41180,
    TAX_TYPE_NOT_FOUND = 41190,
    INVOICE_PICKUP_BIN_NOT_FOUND = 41200,
    DUPLICATE_TRACKING_NUMBER_FOUND = 41210,
    COULD_NOT_UPDATE_INVOICE_STATUS = 41220,
    COULD_NOT_APPROVE_INVOICES = 41230,
    SPLITTABLE_AUCTION_ITEMS_NOT_FOUND = 41240,
    COPY_INVOICE_ERROR = 41250,
    INVOICESPLIT_NOT_FOUND_ERROR = 41260,
}
